import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Verifying session...</div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  // iter 178k: sales_rep can only interact with app via share links.
  // They should never see the Dashboard / Carts / etc.
  if (user && user.role === "sales_rep") {
    return <Navigate to="/sales-rep-home" replace />;
  }

  return children;
};
